import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import { AuthContext } from "../../Context/auth";
import { useLanguage } from "../../Context/language";
import LanguageSelector from "../../Components/LanguageSelector/LanguageSelector";
import WebPkiService from "../../Pki/webpki.service.js";
import AuthenticationService from "../../Pki/authentication.service.js";
import {
  certificadoParaguaiAceito,
  obterDocumentoParaguai,
} from "../../Pki/certificado-paraguai.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./login.css";

function Demo() {
  const { login, loginCertificado } = useContext(AuthContext);
  const { t, isSpanish, isPortuguese } = useLanguage();

  const [logarComCertificado, setlogarComCertificado] = useState(false);
  const [loading, setLoading] = useState(false);
  const [CpfCnpj, setCpfCnpj] = useState("");
  const [senha, setSenha] = useState("");
  const [status, setStatus] = useState("");
  const navigate = useNavigate();

  const webPkiService = new WebPkiService();
  const authenticationService = new AuthenticationService();

  const [selectedCertThumbprint, setSelectedCertThumbprint] = useState("");
  const [certificates, setCertificates] = useState([]);

  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      root.style.height = "100%";
    }
    return () => {
      if (root) {
        root.style.height = "auto";
      }
    };
  }, []);

  function mostraErro(texto) {
    setLoading(false);
    const Alerta = withReactContent(Swal);
    return Alerta.fire({
      title: <p>{t("common.attention")}</p>,
      text: texto,
      icon: "warning",
    });
  }

  function alterarCpfCnpj(event) {
    setStatus("");
    setCpfCnpj(event.target.value);
  }

  function alterarSenha(event) {
    setStatus("");
    setSenha(event.target.value);
  }

  function startPKI() {
    setLoading(true);
    webPkiService.init();
    _loadCertificates();
  }

  async function _loadCertificates() {
    setLoading(true);
    const pais = isSpanish ? "PY" : "BR";
    await webPkiService
      .loadCertificates(pais)
      .then((res) => {
        setCertificates(res);
        setSelectedCertThumbprint(res[0].thumbprint);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function _handleCertSelectionChange(event) {
    setStatus("");
    setSelectedCertThumbprint(event.target.value);
  }

  function cancelButtonHandler() {
    setStatus("");
    setlogarComCertificado(false);
  }

  function refreshButtonHandler() {
    setStatus("");
    _loadCertificates();
  }

  function buttonHandler() {
    setStatus("");
    setlogarComCertificado(true);
    startPKI();
  }

  async function _EntrarSemCertificado() {
    setStatus("");
    setLoading(true);

    setTimeout(async () => {
      try {
        const pais = isSpanish ? "PY" : "BR";
        const isLogged = await login(CpfCnpj, senha, mostraErro, pais);
        if (isLogged) {
          navigate(isSpanish ? "/de/1" : "/notas/nfe");
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        // eslint-disable-next-line
        setStatus(error?.message);
        console.error(error);
      }
    }, 1000);
  }

  async function _EntrarComCertificado() {
    if (isPortuguese) {
      setStatus("");
      setLoading(true);
      setTimeout(async () => {
        try {
          const token = await authenticationService.start().catch((er) => {
            setLoading(false);
            setStatus(`${t("login.error.pki")}`);
            console.error(er);
          });

          if (token) {
            const thumbprint = selectedCertThumbprint;
            await webPkiService.signWithRestPki(thumbprint, token);

            const result = await authenticationService.complete(token);
            if (result.isValid) {
              let ResultCpfCnpj = "";
              if (result.certificate.cnpj) {
                ResultCpfCnpj = result.certificate.cnpj;
              } else {
                ResultCpfCnpj = result.certificate.cpf;
              }

              const isLogged = await loginCertificado(ResultCpfCnpj, mostraErro, "BR");
              if (isLogged) {
                navigate(isSpanish ? "/de/1" : "/notas/nfe");
              } else {
                setLoading(false);
              }
            } else {
              alert(`${t("login.error.invalid_certificate")} ${result.validation}`);
              setLoading(false);
            }
          }
        } catch (error) {
          setLoading(false);
          // eslint-disable-next-line
          setStatus(error?.message);
          console.error(error);
        }
      }, 1000);
    } else {
      await _EntrarComCertificadoParaguai();
    }
  }

  async function _EntrarComCertificadoParaguai() {
    setStatus("");
    setLoading(true);
    setTimeout(async () => {
      try {
        const token = await authenticationService.startParaguai().catch((er) => {
          setLoading(false);
          setStatus(`${t("login.error.pki")}`);
          console.error(er);
        });

        if (token) {
          const thumbprint = selectedCertThumbprint;
          await webPkiService.signWithRestPki(thumbprint, token);

          const result = await authenticationService.completeParaguai(token);
          if (certificadoParaguaiAceito(result)) {
            const ResultCpfCnpj = await obterDocumentoParaguai({
              result,
              certificates,
              thumbprint: selectedCertThumbprint,
              webPkiService,
            });

            const isLogged = await loginCertificado(ResultCpfCnpj, mostraErro, "PY");
            if (isLogged) {
              navigate(isSpanish ? "/de/1" : "/notas/nfe");
            } else {
              setLoading(false);
            }
          } else {
            alert(`${t("login.error.invalid_certificate")} ${result.validation}`);

            setLoading(false);
          }
        }
      } catch (error) {
        setLoading(false);
        // eslint-disable-next-line
        setStatus(error?.message);
        console.error(error);
      }
    }, 1000);
  }

  return (
    <div className="d-flex flex-column flex-lg-row flex-column-fluid">
      {/* Esquerda */}
      <div className="left-side d-flex flex-column">
        <div
          className="left-container d-flex flex-column"
          style={{
            backgroundImage: `url(${toAbsoluteUrl("/img/background.png")})`,
            backgroundColor: "#8d0000",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="left-content d-flex flex-column">
            <a href="https://www.avenzoerp.com/portaldocontador">
              <div className="text-white d-flex justify-content-center align-items-center p-5 pt-lg-10 pb-lg-10">
                <div className="d-flex align-items-center">
                  <div>
                    <img
                      style={{ width: "80px", height: "auto" }}
                      src={toAbsoluteUrl("/img/logo.svg")}
                      alt="Logo Portal do Contador"
                    />
                  </div>

                  <div className="text-white m-4">
                    <p
                      className="fw-bolder"
                      style={{
                        fontSize: "calc(1.75em + 1vw)",
                        outline: 0,
                        lineHeight: "1.2",
                        margin: "0",
                      }}
                    >
                      {t("common.portal_do_contador")}
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </div>

          <div className="telefone d-flex flex-center flex-column text-center">
            <a
              href="https://api.whatsapp.com/send?phone=556740427490"
              rel="noreferrer noopener"
              target="_blank"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              <b>{t("login.phone")}</b>
            </a>
          </div>
        </div>
      </div>

      {/* Direita */}
      <div className="d-flex flex-column flex-lg-row-fluid py-10">
        <div className="d-flex flex-center flex-column flex-column-fluid">
          <div className="w-lg-500px p-10 p-lg-15 mx-auto">
            {!logarComCertificado ? (
              <div className="m-login__signin">
                <form
                  className="form w-100"
                  noValidate="novalidate"
                  id="kt_sign_in_form"
                  action="#"
                >
                  {status && (
                    <div className="mb-lg-15 alert alert-danger">
                      <div className="alert-text font-weight-bold">{status}</div>
                    </div>
                  )}
                  <div>
                    <div className="text-center mb-10">
                      <a
                        href="https://www.avenzoerp.com"
                        className="mb-1 pb-4 pt-4 d-flex flex-center"
                      >
                        <img
                          alt="Logo"
                          src={toAbsoluteUrl("/img/logo-avenzo-preto.svg")}
                          className="bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-100px min-h-lg-120px"
                          style={{ height: "120px" }}
                        />
                      </a>
                    </div>

                    {/* Language Selector */}
                    <LanguageSelector />

                    <div className="fv-row mb-10">
                      <label className="form-label fs-6 fw-bolder text-dark">
                        {t("login.usuario")}
                      </label>
                      <input
                        onChange={alterarCpfCnpj}
                        type="text"
                        className="form-control form-control-lg form-control-solid"
                        id="cpfCnpj"
                        placeholder="CPF/CNPJ"
                        tabIndex="1"
                        autoFocus={true}
                      />
                    </div>
                    <div className="fv-row mb-10">
                      <label className="form-label fw-bolder text-dark fs-6 mb-0">
                        {t("login.senha")}
                      </label>
                      <input
                        onChange={alterarSenha}
                        type="password"
                        className="form-control form-control-lg form-control-solid"
                        id="floatingPassword"
                        placeholder="Senha"
                        autoComplete="off"
                        tabIndex="2"
                      />
                    </div>

                    <div className="text-center">
                      <button
                        type="button"
                        id="kt_sign_in_submit"
                        className="btn btn-lg btn-primary w-100 mb-5 fw-bolder fs-4"
                        disabled={loading}
                        onClick={async () => await _EntrarSemCertificado()}
                      >
                        {!loading && (
                          <span className="indicator-label">{t("login.button.login")}</span>
                        )}
                        {loading && (
                          <span className="indicator-progress" style={{ display: "block" }}>
                            {t("login.loading")}
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </button>

                      {/* begin::Separator */}
                      <div className="text-center text-muted text-uppercase fw-bolder mb-5">
                        {t("login.or")}
                      </div>
                      {/* end::Separator */}

                      <button
                        type="button"
                        id="m_login_signin_certificado"
                        className="btn btn-success btn-flex flex-center btn-lg w-100 mb-5 fw-bolder fs-4"
                        onClick={buttonHandler}
                      >
                        {!loading && (
                          <span className="indicator-label">{t("login.button.certificate")}</span>
                        )}
                        {loading && (
                          <span className="indicator-progress" style={{ display: "block" }}>
                            {t("login.loading")}
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            ) : (
              <div className="m-login__certificado" id="m-login__certificado">
                <form className="form w-100" noValidate="novalidate" id="authForm" action="#">
                  {status && (
                    <div className="mb-lg-15 alert alert-danger">
                      <div className="alert-text font-weight-bold">{status}</div>
                    </div>
                  )}
                  <div>
                    <div className="text-center mb-10">
                      <a
                        href="https://www.avenzoerp.com"
                        className="mb-1 pb-4 pt-4 d-flex flex-center"
                      >
                        <img
                          alt="Logo"
                          src={toAbsoluteUrl("/img/logo-avenzo-preto.svg")}
                          className="bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-100px min-h-lg-120px"
                          style={{ height: "120px" }}
                        />
                      </a>
                      {/* 
                      <div className="text-gray-400 fw-bold fs-4">
                        Escolha o seu certificado digital
                      </div>
                      */}
                    </div>

                    <div className="fv-row mb-10">
                      {/* Render the token in a hidden input field. */}
                      <input type="hidden" name="token" id="tokenField" value="token" />

                      <label
                        className="form-label fs-5 fw-bolder text-dark"
                        htmlFor="certificateSelect"
                      >
                        {t("login.label.certificate")}
                      </label>

                      <select
                        id="certificateSelect"
                        name="certificado"
                        className="form-control-lg selectpicker"
                        style={{ width: "100%" }}
                        value={selectedCertThumbprint}
                        onChange={(e) => _handleCertSelectionChange(e)}
                      ></select>
                    </div>

                    {/* begin::Action */}
                    <div className="text-center">
                      <button
                        type="button"
                        id="m_login_login_certificado_submit"
                        className="btn btn-lg btn-primary w-100 mb-5 fw-bolder fs-4"
                        disabled={loading}
                        onClick={async () => await _EntrarComCertificado()}
                      >
                        {!loading && (
                          <span className="indicator-label">{t("login.button.login")}</span>
                        )}
                        {loading && (
                          <span className="indicator-progress" style={{ display: "block" }}>
                            {t("login.loading")}
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </button>

                      {/* begin::Separator */}
                      <div className="text-center text-muted text-uppercase fw-bolder mb-5">
                        {t("login.or")}
                      </div>
                      {/* end::Separator */}

                      <button
                        type="button"
                        id="m_login_login_certificado_refresh"
                        className="btn btn-success btn-flex flex-center btn-lg w-100 mb-5 fw-bolder fs-4"
                        disabled={loading}
                        onClick={refreshButtonHandler}
                      >
                        {!loading && (
                          <span className="indicator-label">{t("login.button.refresh")}</span>
                        )}
                        {loading && (
                          <span className="indicator-progress" style={{ display: "block" }}>
                            {t("login.loading")}
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </button>

                      <button
                        type="button"
                        id="m_login_login_certificado_cancel"
                        className="btn btn-danger btn-flex flex-center btn-lg w-100 mb-5 fw-bolder fs-4"
                        disabled={loading}
                        onClick={cancelButtonHandler}
                      >
                        <span className="indicator-label">{t("login.button.cancel")}</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Demo;
